import React from 'react';
import CardReport from '../CardReport/index';
import Img from '../../../img/imgs.png';
import { Title, StyledImg, BoxReport } from './style';

const ReportEvolution = () => (
	<BoxReport>
		<Title>Tenha relatórios sobre <br /> a evolução da sua loja</Title>
		<div className="row" style={{ marginBottom: '1px', padding: '0 23px' }}>
			<div className="col-12 col-lg-4 col-xl-4">
				<CardReport
					titleRedCaps="Relatórios exclusivos"
					text="Você terá os dados em tempo real de suas campanhas.
                    Quantidade de cliques, acessos, impressões, leads e até mesmo das conversões.
                    Quanto mais campanhas você realizar, mais a sua loja irá bombar em vendas."
				/>
			</div>
			<StyledImg className="col-8 col-xl-8">
				<img src={Img} alt="" />
			</StyledImg>
		</div>
	</BoxReport>
);

export default ReportEvolution;
